import { Props as ListingProps } from '~components/Listing';

export const listingConfig: ListingProps['config'] = {
  common: {
    timeoutOfficesUpdate: 1000,
    timeoutFiltersUpdate: 1000,
    pageSize: 21,
    showTextBefore: true,
    textBefore: '<h1>Каталог</h1>',
    types: {
      office: 'Офис',
      apartment: 'Апартаменты',
      torg: 'Торговые помещения',
    },
    sorting: {
      direction: 'asc',
      value: {
        ruble: 'cost_r',
        dollar: 'cost_d',
      },
      options: [
        {
          label: 'Цена',
          value: {
            ruble: 'cost_r',
            dollar: 'cost_d',
          },
        },
        {
          label: 'Цена за метр',
          value: {
            ruble: 'costm_r',
            dollar: 'costm_d',
          },
        },
        {
          label: 'Площадь',
          value: 'total_area',
        },
        {
          label: 'Этажность',
          value: 'floor',
        },
      ],
    },
    views: [
      {
        icon: 'th',
        label: 'Плитка',
        value: 'grid',
      },
      {
        icon: 'table',
        label: 'Таблица',
        value: 'list',
      },
    ],
  },
  catalog: {
    category: null,
    currency: 'ruble',
    query: {},
    list: [],
    type: 'catalog',
    view: 'grid',
    sortIrrelevantProducts: false,
    splitByGroups: false,
    visible: true,
    pagination: false,
    emptyMessageTitle:
      'Нет объектов в избранном. Пожалуйста, добавьте объекты.',
    emptyMessageDesc:
      'Выберите параметры в фильтре, чтобы подобрать подходящие предложения <br/> или позвоните нам по телефону <a href="tel:84957988800">+7 495 798-88-00</a> и мы сделаем это за Вас',
  },
};
